<template>
  <v-card flat>
    <v-card-title class="subtitle-1 pa-0 ma-0">
      <span>{{ value.titulo }}</span>
      <v-switch
        v-model="value.habilitado"
        color="secondary"
        class="ml-4"
        dense
      />
    </v-card-title>
    <v-card-text
      v-show="value.habilitado"
      class="pa-0 ma-0"
    >
      <v-autocomplete
        v-model="value.selecionado"
        :items="value.lista"
        :item-text="value.itemText"
        :label="value.label ? value.label : 'Selecione'"
        placeholder="Digite para pesquisar..."
        :search-input.sync="search"
        :multiple="value.multiplo"
        chips
        deletable-chips
        :prepend-icon="value.icone"
        return-object
        dense
        @change="search = ''"
      >
        <!-- Inclusão da Opção para selecionar todos -->
        <template
          v-if="value.lista.length > 0"
          v-slot:prepend-item
        >
          <v-list-item @click="toggleItens">
            <v-list-item-action>
              <v-icon :color="value.selecionado.length > 0 ? 'primary' : ''">
                {{ icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Selecionar {{ value.todas ? 'Todas' : 'Todos' }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2" />
        </template>

        <!-- Customização dos chips selecionados -->
        <template v-slot:selection="data">
          <v-chip
            :input-value="data.selected"
            class="chip--select-multi my-1"
            close
            color="secondary"
            small
            text-color="white"
            @click:close="remove(data.item)"
          >
            {{ data.item[value.itemText] }}
          </v-chip>
        </template>
      </v-autocomplete>
      <slot name="children" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FiltroSelect',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        titulo: '',
        habilitado: true,
        selecionado: [],
        lista: [],
        itemText: 'nome',
        icone: 'checklist',
        multiplo: true,
        todas: false,
      }),
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      search: '',
    };
  },

  computed: {
    selectAllItens() {
      return this.value.selecionado.length === this.value.lista.length;
    },
    selectSomeItens() {
      return this.value.selecionado.length > 0 && !this.selectAllItens;
    },
    icon() {
      if (this.selectAllItens) {
        return 'check_box';
      }
      if (this.selectSomeItens) {
        return 'indeterminate_check_box';
      }
      return 'check_box_outline_blank';
    },
  },

  watch: {
    'value.habilitado': function (value) {
      if (!value) {
        this.setDefault();
      }
    },
    disable(value) {
      if (value) {
        this.value.habilitado = false;
      }
    },
  },

  methods: {
    remove(item) {
      this.value.selecionado = this.value.selecionado.filter((i) => i.id !== item.id);
    },
    setDefault() {
      this.value.selecionado = [];
    },
    toggleItens() {
      this.$nextTick(() => {
        if (this.selectAllItens) {
          this.value.selecionado = [];
        } else {
          this.value.selecionado = [...this.value.lista];
        }
      });
    },
  },
};
</script>
